<bcu-local-spinner [size]="40" [visible]="(courtBooking$ | async).isLoading" *ngIf="(courtBooking$ | async).isLoading">
</bcu-local-spinner>
<div class="container  my-3" *ngIf="(courtBooking$ | async).loaded && (courtBooking$ | async).data as courtBooking">
    <div class="row card shadow p-4 border-bottom no-gutters color-dark-gray-bg text-white">
        <div class="col">
            <div class="row no-gutters py-2 px-3">
                <div class="col-3">
                    <div class="font-weight-bold"><h3>{{courtBooking.categoryOptions.category.name}} {{", " + courtBooking.categoryOptions.name}}</h3></div>
                    <div>{{'CourtEventDetails.CourtBookingDetailsName' | translate}}</div>
                </div>
                <div class="col-5"></div>
                <div class="col-4">
                    <div class="row m-0 no-gutters justify-content-end">
                        <div class="col-auto m-0" *ngIf="courtBooking.isNoShowAllAvailable">
                            <button type="button" class="btn btn-light-red-outline" (click)="onNoShowAllClicked()">{{'CourtEventDetails.CourtBookingNoShowAllBtn' | translate}}</button>
                        </div>
                        <div class="col-auto m-0" *ngIf="courtBooking.isCheckInAllAvailable">
                            <button type="button" class="btn btn-light-blue-outline" (click)="onCheckInAllClicked()">{{'CourtEventDetails.CourtBookingCheckInAllBtn' | translate}}</button>
                        </div>
                        <div class="col-auto m-0 text-right" *ngIf="courtBooking.isCancellationAvailable">
                            <button type="button" class="btn btn-light-red" (click)="onCancelClicked()">{{'CourtEventDetails.CourtBookingCancelBtn' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters px-3">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>
            <div class="row no-gutters py-2 px-3">
                <div class="col text-left">
                    <span class="ic_bs_calendar mr-2"></span> {{courtBooking.date | bcDate: 'dddd'}}, {{courtBooking.date | bcDate: 'MMM Do YY'}}
                </div>                    
                <div class="col text-left">
                    <span class="ic-cb-time mr-2"></span>
                    {{courtBooking.timeFromInMinutes | timeDisplay : true}} -
                    {{courtBooking.timeToInMinutes | timeDisplay}}
                </div>
                <div class="col text-left">
                    <span class="ic_bs_court mr-2"></span>
                    {{courtBooking.court.name}} <span *ngIf="courtBooking.court.tennisType">({{courtBooking.court.tennisType.name}})</span>
                </div>
                <div class="col text-left">
                    <app-court-event-status-pill [status]="courtBooking.status"></app-court-event-status-pill>
                </div>
                <div class="col">
                </div>
            </div>

            <div class="row no-gutters px-3" *ngIf="isAnyNote(courtBooking)">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>

            <div class="py-2 px-3" *ngIf="isAnyNote(courtBooking)">
                <app-court-event-notes-details [notes]="courtBooking.notes"></app-court-event-notes-details>  
            </div>

            <div class="row no-gutters pt-2 px-3">
                <div class="col">
                    <span class="clickable" (click)="onAddNote()">{{'CourtEventDetails.AddNote' | translate}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row card shadow m-0 p-0 border-bottom no-gutters white-bg" *ngIf="courtBooking.players.length">
        <div class="col">
        <app-court-booking-players
            [players]="courtBooking.players"
            (onChangePlayerClicked)="onChangePlayer($event)"
            (onCheckInPlayerClicked)="onCheckInPlayer($event)"></app-court-booking-players>
        </div>
    </div>    
    
    <div class="card mt-4" *ngIf="courtBooking.timelineItems.length">       
        <app-court-event-timeline [timelines]="courtBooking.timelineItems"></app-court-event-timeline>        
    </div>
</div>